// @ts-nocheck

import React from 'react';

import CommonForm, {
  type CommonFormProps,
} from '../../../components/hoc/common/handbook/CommonForm';
import type { Setting } from '../../../lib/types';
import Grid, { GridItem } from '../../../components/layout/Grid';
import { FormField } from '../../../components/Form';
import { StyledInput } from '../../../components/hoc/common/components/elements';

export default (props: CommonFormProps<Partial<Setting>>) => {
  return (
    <CommonForm {...props}>
      {({ setFieldValue }) => {
        return (
          <>
            <Grid gutter="16px">
              <GridItem>
                <FormField label="Ключ" fast required name="key">
                  {({ name, value }: any) => (
                    <StyledInput name={name} disabled value={value} />
                  )}
                </FormField>
              </GridItem>
              <GridItem>
                <FormField label="Значение" fast required name="value">
                  {({ name, value }: any) => (
                    <StyledInput
                      name={name}
                      value={value}
                      onChange={(e) => setFieldValue(name, e.target.value)}
                    />
                  )}
                </FormField>
              </GridItem>
            </Grid>
          </>
        );
      }}
    </CommonForm>
  );
};
